import type { PaymentsLedgerTranslations } from "../interfaces/paymentsLedger";

export const paymentsLedgerTranslations: PaymentsLedgerTranslations = {
  page_title: "Livro contábil",
  page_subtitle:
    "Lançamentos de partida dobrada de cada operação do motor de pagamentos: reservas, liquidações e estornos",
  refresh_button: "Atualizar",
  refresh_aria: "Atualizar os lançamentos da operação",
  live_updated_at: "Atualizado {{time}}",
  why_banner:
    "Cada lançamento fecha débitos contra créditos por moeda: é o mesmo invariante que o motor valida ao registrar. Um lançamento desbalanceado é problema do registro, não desta tela.",

  error_load: "Não foi possível carregar os lançamentos",
  error_load_detail:
    "O motor de pagamentos não respondeu. Nenhum valor parcial é exibido: tente novamente para ler o livro completo.",
  error_retry: "Tentar novamente",

  picker_title: "Operações",
  picker_description: "O livro é lido por operação: escolha uma ou cole o ID dela.",
  picker_tab_payouts: "Dispersões",
  picker_tab_payins: "Recebimentos",
  picker_tab_swaps: "Conversões",
  picker_search_placeholder: "Colar ID da operação",
  picker_search_hint: "Abre a operação seja qual for o tipo.",
  picker_search_invalid: "Esse ID não tem formato válido.",
  picker_search_resolving: "Buscando a operação…",
  picker_search_not_found: "Esse ID não tem lançamentos em nenhum tipo de operação.",
  picker_search_failed: "Não foi possível verificar esse ID. Tente novamente.",
  picker_filter_org_label: "Organização",
  picker_filter_all_orgs: "Todas as organizações",
  picker_filter_status_label: "Status",
  picker_filter_all_statuses: "Todos os status",
  picker_filter_corridor_label: "Corredor",
  picker_filter_all_corridors: "Todos os corredores",
  picker_filter_date_label: "Data",
  picker_filter_all_dates: "Qualquer data",
  picker_filter_last_days: "Últimos {{days}} dias",
  picker_clear: "Limpar",
  picker_empty_title: "Sem resultados",
  picker_empty_description: "Nenhuma operação corresponde aos filtros selecionados.",
  picker_error: "Não foi possível carregar a lista de operações.",
  picker_open_button: "Operações",
  picker_summary: "{{from}}–{{to}} de {{total}}",
  picker_org_unknown: "Organização sem nome",

  status_swap_created: "Criada",
  status_swap_completed: "Concluída",
  status_swap_failed: "Falhou",

  empty_title: "Escolha uma operação",
  empty_description:
    "Cada operação do motor de pagamentos deixa aqui seu rastro contábil: quais contas se moveram, em que direção e com qual saldo ficaram.",

  header_kind_payout: "Dispersão",
  header_kind_payin: "Recebimento",
  header_kind_swap: "Conversão",
  header_operation_id: "ID da operação",
  header_organization: "Organização",
  header_organization_unknown: "Não identificada",
  header_created: "Primeiro lançamento",
  header_currencies: "Moedas",
  header_export_csv: "Exportar CSV",
  header_view_operation: "Ver operação",
  header_status_unavailable:
    "Não foi possível ler o status atual da operação. Os lançamentos exibidos são os reais.",
  copy_success: "Copiado",
  copy_aria: "Copiar",

  kpi_entries_label: "Lançamentos",
  kpi_entries_meta: "Em ordem de registro",
  kpi_legs_label: "Partidas",
  kpi_legs_meta: "Em {{accounts}} contas",
  kpi_balance_label: "Partida dobrada",
  kpi_balance_ok: "Fecha",
  kpi_balance_broken: "Não fecha",
  kpi_balance_meta: "Débitos = créditos, por moeda",
  kpi_reversals_label: "Estornos",
  kpi_reversals_meta: "Lançamentos contrários que anulam um anterior",
  kpi_reversals_none: "Nenhum",
  totals_debit: "Débitos",
  totals_credit: "Créditos",
  unbalanced_heading: "Há um lançamento que não fecha",
  unbalanced_text:
    "Em pelo menos uma moeda os débitos não igualam os créditos. O motor valida esse fechamento ao registrar, então isso merece revisão com o time de plataforma antes de conciliar.",

  entries_title: "Lançamentos",
  entries_description: "Cada lançamento move ao menos duas contas e fecha por si mesmo.",
  entry_index: "Lançamento #{{index}}",
  entry_badge_reversal: "Estorno do lançamento #{{index}}",
  entry_badge_reversed: "Estornado pelo lançamento #{{index}}",
  entry_balanced: "Fecha",
  entry_unbalanced: "Não fecha",
  entry_id_label: "ID do lançamento",
  entry_reason: "Motivo",
  no_entries_title: "Ainda sem lançamentos",
  no_entries_description:
    "Esta operação não registrou movimento contábil. Acontece, por exemplo, com um recebimento cujo QR foi emitido e ninguém pagou: o lançamento é escrito quando o dinheiro se move.",

  entry_payout_reserve: "Reconhecimento e reserva de fundos",
  entry_payout_settle: "Liquidação da dispersão",
  entry_payout_release: "Liberação de fundos",
  entry_payin_detected: "Dinheiro recebido (em suspenso)",
  entry_payin_confirmed: "Recebimento creditado",
  entry_swap: "Conversão entre carteiras",
  entry_coloca_top_up: "Recarga da Coloca na carteira do cliente",
  entry_coloca_refund: "Reembolso da Coloca na carteira do cliente",
  entry_coloca_debit: "Débito da Coloca na carteira do cliente por um envio manual",
  entry_coloca_debit_sent: "Envio manual de um débito da Coloca registrado: sai da tesouraria",
  entry_coloca_debit_cancelled: "Débito da Coloca cancelado: o saldo volta ao cliente",
  entry_reversal: "Estorno",
  entry_generic_payin: "Movimento de recebimento",
  entry_generic_payout: "Movimento de dispersão",
  entry_generic_swap: "Movimento de conversão",
  entry_generic_fee: "Movimento de tarifa",
  entry_generic_adjust: "Ajuste manual",
  entry_generic_reverse: "Estorno",

  th_account: "Conta",
  th_debit: "Débito",
  th_credit: "Crédito",
  th_balance_after: "Saldo resultante",
  totals_row_label: "Totais",
  direction_debit: "Débito",
  direction_credit: "Crédito",

  account_cash_at_provider: "Caixa no provedor",
  account_cash_at_provider_hint:
    "Dinheiro que o provedor do corredor mantém em nome da Coloca. É um ativo: sobe quando entra dinheiro e cai quando se paga.",
  account_client_liability: "Passivo com o cliente",
  account_client_liability_hint:
    "O que a Coloca deve à organização. É o espelho contábil do saldo da carteira dela.",
  account_payout_in_transit: "Dispersões em trânsito",
  account_payout_in_transit_hint:
    "Dinheiro já comprometido com um beneficiário e ainda não liquidado. Baixa ao pagar, falhar ou cancelar.",
  account_manual_send_in_transit: "Envios manuais em trânsito",
  account_manual_send_in_transit_hint:
    "O que os débitos de carteiras têm reservado para um envio manual ainda não registrado.",
  account_payin_suspense: "Recebimentos em suspenso",
  account_payin_suspense_hint:
    "Dinheiro recebido que ainda não foi creditado a nenhuma organização. Deve ficar em zero quando o recebimento é confirmado.",
  account_fx_position: "Posição de câmbio",
  account_fx_position_hint:
    "Ponte entre as duas moedas de uma conversão. Seu saldo por moeda é a exposição cambial da Coloca, incluindo os resíduos de arredondamento.",
  account_fee_revenue: "Receita de tarifas",
  account_fee_revenue_hint:
    "O que a Coloca cobrou na operação: a comissão do corredor e, se houve conversão, a tarifa de câmbio.",
  account_provider_cost: "Custo de provedor",
  account_provider_cost_hint:
    "O que o provedor cobrou da Coloca. Só é registrado quando o modelo econômico do corredor é absorvido.",
  account_tax_payable: "Imposto a pagar · {{tax}}",
  account_tax_payable_hint:
    "Imposto cobrado ou assumido na operação que a Coloca deve à autoridade tributária.",
  account_tax_expense: "Despesa de imposto · {{tax}}",
  account_tax_expense_hint: "Imposto que a Coloca assume na operação em vez de cobrá-lo do cliente.",
  account_coloca_treasury: "Tesouraria da Coloca",
  account_coloca_treasury_hint:
    "Fundos próprios da Coloca, já em um provedor, creditados a clientes pela equipe. Conciliados com os saldos reais dos provedores.",
  account_unknown_badge: "Conta não catalogada",
  account_type_asset: "Ativo",
  account_type_liability: "Passivo",
  account_type_revenue: "Receita",
  account_type_expense: "Despesa",
  account_type_suspense: "Transitória",
  scope_global: "Global",
  scope_provider: "Conta de provedor",
  scope_organization: "Organização",

  rollup_title: "Somas e saldos por conta",
  rollup_description: "Como cada conta ficou após toda a operação, estornos incluídos.",
  th_net: "Líquido",
  th_last_balance: "Saldo de fechamento",
  net_side_debit: "No débito",
  net_side_credit: "No crédito",
  net_flat: "Sem efeito líquido",

  trail_title: "Histórico de status",
  trail_description: "Quando o motor decidiu cada mudança, para cruzar com os lançamentos.",
  trail_toggle_show: "Ver histórico de status",
  trail_toggle_hide: "Ocultar histórico de status",
  trail_empty: "Esta operação não registrou mudanças de status.",
  trail_error: "Não foi possível ler o histórico de status.",
  trail_initial: "Criação",
  trail_source_internal_api: "Painel interno",
  trail_source_provider_webhook: "Confirmação do provedor",
  trail_source_system: "Automático",
  trail_reason: "Motivo",
};
